<template>
  <svg
    class="starfield"
    viewBox="0 0 1600 900"
    preserveAspectRatio="xMidYMid slice"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <path id="spk" d="M10 0 C11 6 14 9 20 10 C14 11 11 14 10 20 C9 14 6 11 0 10 C6 9 9 6 10 0 Z" />
    </defs>
    <circle
      v-for="(s, i) in stars"
      :key="'s' + i"
      class="twinkle"
      :cx="s.x"
      :cy="s.y"
      :r="s.r"
      :fill="s.fill"
      :style="twinkleStyle(s)"
    />
    <use
      v-for="(p, i) in sparkles"
      :key="'p' + i"
      class="twinkle"
      href="#spk"
      fill="#bff7f3"
      :transform="'translate(' + p.x + ' ' + p.y + ') scale(' + p.s + ')'"
      :style="twinkleStyle(p)"
    />
  </svg>
</template>

<script>
export default {
  name: "Starfield",
  props: {
    // number of small twinkling stars
    count: { type: Number, default: 460 },
    sparkleCount: { type: Number, default: 36 }
  },
  data() {
    return { stars: [], sparkles: [] };
  },
  created() {
    const rand = (a, b) => a + Math.random() * (b - a);
    const round = (n, d = 2) => Number(n.toFixed(d));

    const stars = [];
    for (let i = 0; i < this.count; i++) {
      stars.push({
        x: Math.round(rand(0, 1600)),
        y: Math.round(rand(0, 900)),
        r: round(rand(0.5, 2.2), 1),
        fill: Math.random() < 0.3 ? "#bff7f3" : "#ffffff",
        omin: round(rand(0, 0.15)),
        omax: round(rand(0.35, 1)),
        dur: round(rand(1.8, 6)),
        delay: round(rand(0, 6))
      });
    }

    const sparkles = [];
    for (let i = 0; i < this.sparkleCount; i++) {
      sparkles.push({
        x: Math.round(rand(30, 1570)),
        y: Math.round(rand(20, 840)),
        s: round(rand(0.4, 1.3)),
        omin: round(rand(0, 0.1)),
        omax: round(rand(0.3, 0.85)),
        dur: round(rand(2.5, 7)),
        delay: round(rand(0, 7))
      });
    }

    this.stars = stars;
    this.sparkles = sparkles;
  },
  methods: {
    // String style so CSS custom properties survive Vue 2's style binding.
    twinkleStyle(s) {
      return (
        "--omin:" + s.omin +
        ";--omax:" + s.omax +
        ";animation-duration:" + s.dur + "s" +
        ";animation-delay:-" + s.delay + "s"
      );
    }
  }
};
</script>

<style scoped>
.starfield {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.twinkle {
  opacity: var(--omax);
  animation-name: cvpa-twinkle;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
}

@keyframes cvpa-twinkle {
  0%,
  100% {
    opacity: var(--omin);
  }
  50% {
    opacity: var(--omax);
  }
}

/* Respect users who prefer reduced motion */
@media (prefers-reduced-motion: reduce) {
  .twinkle {
    animation: none;
  }
}
</style>
